import { render, staticRenderFns } from "./RecIngredientCard.vue?vue&type=template&id=12fafa50&scoped=true"
import script from "./RecIngredientCard.vue?vue&type=script&lang=js"
export * from "./RecIngredientCard.vue?vue&type=script&lang=js"
import style0 from "./RecIngredientCard.vue?vue&type=style&index=0&id=12fafa50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fafa50",
  null
  
)

export default component.exports